
export namespace StringUtils {
  export function split(value: string, separator: string, limit?: number, keepRest?: boolean) {
    if (!value.length)
      return [];

    let tokens = value.split(separator, limit);

    if (keepRest) {
      let lengthBefore = tokens.reduce((n, x) => n + x.length, 0) + separator.length * (tokens.length - 1);
      if (lengthBefore < value.length)
        tokens[tokens.length - 1] += value.substring(lengthBefore);
    }

    return tokens;
  }
}
